import React from 'react';
import Link from 'next/link';
import { PrimaryCtaLinkProps } from './types';
import { buttonBase, buttonSizes, buttonVariants } from '../Button/buttonStyles';

const PRIMARY_CTA_STYLES = {
  default: `${buttonBase} ${buttonSizes.default} ${buttonVariants.primary} max-sm:w-full whitespace-nowrap cursor-pointer`,

  footer: `${buttonBase} ${buttonSizes.default} ${buttonVariants.navPrimary} whitespace-nowrap cursor-pointer w-full sm:w-auto`,

  'mobile-row': `${buttonBase} ${buttonSizes.default} ${buttonVariants.mobileRowPrimary} flex-1 text-center font-bold`,

  'hero-banner': `${buttonBase} ${buttonSizes.default} ${buttonVariants.heroPrimary} whitespace-nowrap`,

  'hero-location': `${buttonBase} ${buttonSizes.default} ${buttonVariants.heroPrimary} whitespace-nowrap`,

  'desktop-navigation': `${buttonBase} ${buttonSizes.default} ${buttonVariants.navPrimary} whitespace-nowrap cursor-pointer`,

  'layout-highlighted': `${buttonBase} ${buttonSizes.default} ${buttonVariants.primary} whitespace-nowrap cursor-pointer`,

  'sticky-mobile-footer': `${buttonBase} ${buttonSizes.default} ${buttonVariants.primary} whitespace-nowrap cursor-pointer`,
} as const;

export const PrimaryCtaLink: React.FC<PrimaryCtaLinkProps> = ({
  buttonText,
  linkUrl,
  target,
  relAttribute,
  className = '',
  layout = 'default',
  children,
}) => {
  if (!linkUrl) return null;

  return (
    <Link
      href={linkUrl}
      target={target}
      rel={relAttribute}
      className={`${PRIMARY_CTA_STYLES[layout]} ${className}`.trim()}
    >
      {children || buttonText}
    </Link>
  );
};

export default PrimaryCtaLink;
